import { forwardRef, useState, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const SIZE_CLASS = {
  xs: "size-6 text-[10px]",
  sm: "size-8 text-xs",
  md: "size-10 text-sm",
  lg: "size-12 text-base",
  xl: "size-16 text-lg",
} as const;

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  alt?: string;
  size?: keyof typeof SIZE_CLASS;
  radius?: "sm" | "md" | "xl" | "full";
  color?: string;
}

/** Reemplazo de `<Avatar>` de Mantine · imagen si `src` carga, si no las iniciales de `children`. */
export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({ src, alt, size = "md", radius = "full", color = "multiva", className, style, children, ...props }, ref) => {
    const [imgFailed, setImgFailed] = useState(false);
    const showImg = src && !imgFailed;
    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex shrink-0 items-center justify-center overflow-hidden font-semibold text-white",
          radius === "full" ? "rounded-full" : radius === "sm" ? "rounded-sm" : radius === "xl" ? "rounded-xl" : "rounded-md",
          SIZE_CLASS[size],
          className
        )}
        style={{ backgroundColor: showImg ? undefined : `var(--color-${color}-600)`, ...style }}
        {...props}
      >
        {showImg ? (
          <img src={src} alt={alt ?? ""} className="size-full object-cover" onError={() => setImgFailed(true)} />
        ) : (
          children
        )}
      </div>
    );
  }
);
Avatar.displayName = "Avatar";
